import Component from './WorkTimeLastActive.vue';

export default {
  install(Vue) {
    Vue.component('BkfIconWorkTimeLastActive', Component);
  },
};
